<script setup lang="ts">
import { AppInput } from '@shared/ui/inputs'

import {
  useInputState,
} from '../../../../model/additional-info/support/info-invoice-creation/input-state.hook'

defineOptions({
  name: 'InputState',
})

const {
  inputType,
  model,
  placeholder,
} = useInputState()
</script>

<template>
  <AppInput
    v-model="model"
    :type="inputType"
    :placeholder="placeholder"
  />
</template>
